<div class="field" #stripeElementRef>
  <ng-container *ngIf="state !== 'ready' && loadingTemplate">
    <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
  </ng-container>
</div>
